/**
 * Created by agengmaulana on 5/5/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'
import List_Report_Abuse from '../comment_report_abuse/comment_sub_report'
import {observer} from 'mobx-react'
import {observable} from 'mobx'
import $ from 'jquery'

@observer
export default class Comment_Report_Abuse extends React.Component{

    @observable showLaporkan = false
    @observable actived = ''
    @observable textlapor = this.props.status_lapor
    @observable valueLaporkan = ''

    render(){

        const {datFunction,j} = this.props;
        var ok = this.textlapor == 0 ? 'Laporkan' : 'Dilaporkan'
        var lapor_name = this.showLaporkan ? 'Tutup' : ok
        return(
            <div className={styles.cmt_dropdown+' '+styles.cmt_fr+' '+this.actived}>
                <a href="javascript:void(0);" className={styles.cmt_lapor+' '+styles.cmt_href} onClick={this.handleToggle} >{lapor_name}</a>
                {this.showLaporkan ? <List_Report_Abuse id={this.props.id} change={this.change} closeLapor={this.closeLapor} valueLaporkan={this.valueLaporkan} submitLaporkan={this.submitLaporkan} dataStore={datFunction} />: null}

            </div>
        )
    }

    submitLaporkan=(e)=>{
        e.preventDefault();

        let Lapor = {
            'artikel' : this.props.datFunction.configKomentar.identifier,
            'type': this.valueLaporkan ,
            'id': this.props.id
        }

        if(this.props.datFunction.profile.id == ''){
            this.props.datFunction.configKomentar.onmasuk()
        }
        else {
        if(this.valueLaporkan == ""){
            // this.props.datFunction.show = true;
            // this.props.datFunction.title = 'Peringatan';
            // this.props.datFunction.text = 'Anda belum memilih laporan';
            this.props.datFunction.configKomentar.onalert('Anda belum memilih laporan')

        }
        else {
            // this.props.datFunction.show = true;
            // this.props.datFunction.title = 'Sukses';
            // this.props.datFunction.text = 'Laporan anda berhasil dikirim';
            this.props.datFunction.sendLapor(Lapor);
            // this.textlapor ='Dilaporkan'
            this.valueLaporkan = '';
            this.props.datFunction.configKomentar.onalert('Laporan anda berhasil dikirim')

        }
        this.closeLapor()
        }

    }

    change=(e)=>{

        this.valueLaporkan =e.currentTarget.value

    }

    handleToggle=()=>{
        if(this.textlapor == 0){
        this.showLaporkan = !this.showLaporkan
        this.actived = styles.cmt_aktif
        }
    }

    closeLapor=()=>{
        this.showLaporkan = false
    }
}



// WEBPACK FOOTER //
// ./static/src/component/comment_report_abuse/comment_report_abuse.js